import { Component, OnInit, Injector, Inject } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-letter-popup',
  templateUrl: './add-letter-popup.component.html',
  styleUrls: ['./add-letter-popup.component.scss'],
})
export class AddLetterPopupComponent implements OnInit {
  addlLetterName: any;
  addEmailSubject: any;
  sendIncrementEmailLetter: any;
  loggedInUserCompanyID: any;
  buttonColorName: any;
  fromYear: any;
  toYear: any;
  isInValidlLetterName: boolean = false;
  isInValidLetterSubject: boolean = false;
  isInvalidLetterBody: boolean = false;
  getIncrementFyYearList: any[] = [];
  letterNameArray: any = [];
  loggedInCompanyFiscalyear: any;
  AddLetterContent: any = '';
  isDisabledIncrementLetter: any = false;

  // editorConfig: AngularEditorConfig = {
  //   editable: true,
  //   spellcheck: true,
  //   height: '400px',
  //   minHeight: '0',
  //   maxHeight: 'auto',
  //   width: 'auto',
  //   minWidth: '0',
  //   translate: 'yes',
  //   enableToolbar: true,
  //   showToolbar: true,
  //   placeholder: 'Enter Email here...',
  //   defaultParagraphSeparator: '',
  // }

  constructor(private encryptionService: EncryptionService, private httpService: HttpService,
    private config: Config, public dialog: MatDialog, private injector: Injector,
    public dialogRef: MatDialogRef<AddLetterPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }
  rowID: any
  colID: any
  getIncrementLetterData: any = [];
  letterId: any
  departmentName: any;
  band: any;
  ratingId: any
  letterCombination: any;
  existingLetterNames: any[] = [];
  errorMessage: any;
  bandRowId: any;
  dialogData: any;
  editorConfig: any
  editorReady: boolean = false; // ✅ Control rendering: boolean = false; // ✅ Control rendering
  ngOnInit() {
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.rowID = this.data.rowID || 0;
    this.colID = this.data.columnID || 0;
    this.bandRowId = this.data.bandRowId || 0;
    this.addlLetterName = this.data.existingLetterName || '';
    this.addEmailSubject = this.data.subject;
    this.departmentName = this.data.department || '';
    this.letterId = this.data.id || null;
    this.letterCombination = this.data.letterCombination || '';
    this.band = this.data.band || '';
    this.ratingId = this.data.ratingId || null;
    if (this.data.isMDApprove == true) {
      this.isDisabledIncrementLetter = true
    } else {
      this.isDisabledIncrementLetter = false
    }

   this.initializeEditor();
    setTimeout(()=>{
      this.AddLetterContent = this.data?.body || this.getDefaultContent();
    },200)
  
    this.getIncrementFyYear();
  }


  initializeEditor() {
 
  this.editorConfig = {
    enter: 'BR',
    height: 430,
    toolbarSticky: false,
    toolbarAdaptive: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: 'insert_as_html',
    language: 'en',
    i18n: {
      en: {
        'Paste as HTML': 'Paste',
        'Your code is similar to HTML. Keep as HTML?':
          'Do you want to keep this content as it is?',
      }
    },
    uploader: { insertImageAsBase64URI: true },
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'left', 'center', 'right', 'justify', '|',
      'preview', '|',
      'undo', 'redo', '|',
      'fontsize'
    ]
  };



  }

  getDefaultContent(): string {
    return `Date: [DD/MM/YYYY]\n
To,\n
[Employee's Name]\n
[Employee's Designation]\n
[Department]\n
[Employee's office location]\n
Subject:- Salary Increment Notification\n
Dear [Employee's Name],\n
Basis your annual performance for the year 23-24, you have been awarded a performance rating of [rating] and we are pleased to inform you basis your band, your effective all inclusive increment %ge is [Increment %ge]. This increment reflects your hard work, dedication, and the significant contributions you have made to the company. Your revised annual CTC post increment is [New annual CTC Amount].\n
Promotion content: We are also delighted to inform that you have been promoted wef 1st April 2024 and your new designation is [revised designation]. Please note that the revised salary will be effective from 1st April 2024 and will reflect in your payslip.\n
We appreciate your continued efforts and dedication to your role. If you have any questions or require further clarification regarding this increment, please feel free to reach out to the HR department.\n
Congratulations!!\n
Sincerely,\n
Digital signature\n
Name of Head HR\n
Designation`
      .replace(/\n/g, '<br />');
  }
  addToEditor(textToAdd: string) {
  const editor = document.getElementById('htmlDiv');
  if (editor) {
    let htmlToInsert: string;

    // If it's not PromotionContent, make it bold
    if (textToAdd !== '#PromotionContent#') {
      htmlToInsert = `<span><b>${textToAdd}</b></span>`;
    } else {
      htmlToInsert = `<span>${textToAdd}</span>`;
    }

    document.execCommand('insertHTML', false, htmlToInsert);
  }
}

  isValicIncrementLetter() {
    this.isInValidlLetterName = !this.addlLetterName?.trim();
    this.isInValidLetterSubject = !this.addEmailSubject?.trim();
    this.isInvalidLetterBody = !this.AddLetterContent?.trim();
    console.log(this.isInValidlLetterName + "line 162");

  }

  getIncrementFyYear() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result: any) => {
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        fromYear: ele.fromYear,
        toYear: ele.toYear,
        year: `${ele.fromYear}-${ele.toYear}`,
      }));
      const currentYear = new Date().getFullYear();
      let yearValue = '';

      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
      }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.fromYear = this.getIncrementFyYearList[selectedYearIndex].fromYear;
      this.toYear = this.getIncrementFyYearList[selectedYearIndex].toYear;
    })
  }

  onClickSaveBtn() {
    const lettersName = sessionStorage.getItem('LettersName');
    this.letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    this.isValicIncrementLetter();
    console.log(this.isInValidlLetterName + "line 199");
    if (!this.isInValidlLetterName && !this.isInValidLetterSubject && !this.isInvalidLetterBody) {
      this.isInValidlLetterName = false;
      this.isInValidLetterSubject = false;
      this.isInvalidLetterBody = false;
      const LetterTextContent = this.stripHtmlTags(this.AddLetterContent);

      if (this.letterNameArray.includes(this.addlLetterName.trim())) {
        this.errorMessage = true;
      } else {
        this.errorMessage = false;
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Increment letter successfully added',
            btn1: 'Cancel',
            btn2: 'Yes',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            const formData = {
              rowId: this.rowID,
              bandRowId: this.bandRowId,
              colId: this.colID,
              body: this.decodeHtmlAndFormat(this.AddLetterContent).replace(/&(?!amp;|lt;|gt;|quot;|apos;|#\d+;|#x[0-9a-fA-F]+;)/g, '&amp;'),
              letterName: this.addlLetterName,
              subject: this.addEmailSubject,
              department: this.departmentName,
              id: this.letterId
            };
            this.dialogRef.close(formData);
            this.letterNameArray.push(this.addlLetterName.trim());
            sessionStorage.setItem('LettersName', JSON.stringify(this.letterNameArray));
          }
        });
      }
    }
  }

  stripHtmlTags(content: string): string {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.innerText;
  }

  onClickDiscardChanges() {
    const lettersName = sessionStorage.getItem('LettersName');
    this.letterNameArray = lettersName ? JSON.parse(lettersName) : [];
    this.addlLetterName = " ";
    this.addEmailSubject = " ";
    this.sendIncrementEmailLetter = " ";
    this.isInValidlLetterName = false;
    this.isInValidLetterSubject = false;
    this.isInvalidLetterBody = false;
    this.letterNameArray.push(this.addlLetterName.trim());
    sessionStorage.setItem('LettersName', JSON.stringify(this.letterNameArray));
    this.dialogRef.close();
    console.log(this.isInValidlLetterName + "line 263");
  }

  onClickRemoveLetterSubject() {
    if (this.dialogData !== null) {
      this.addEmailSubject = '';
    }
  }

  onClickClosePopup() {
    if (this.data.existingLetterName == null) {
      this.dialogRef.close();
    } else {
      const lettersName = sessionStorage.getItem('LettersName');
      this.letterNameArray = lettersName ? JSON.parse(lettersName) : [];

      this.letterNameArray.push(this.data.existingLetterName.trim());
      sessionStorage.setItem('LettersName', JSON.stringify(this.letterNameArray));
      this.dialogRef.close();
    }
  }
  decodeHtmlAndFormat(html: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    let decoded = txt.value;

    // ✅ Remove unwanted metadata and tags
    decoded = decoded
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<meta[^>]*>/gi, '')
      .replace(/<\?xml[^>]*\?>/gi, '');

    // ✅ Clean common formatting issues
    decoded = decoded
      .replace(/\\n/g, '\n')                  // Convert escaped \n to actual newline
      .replace(/(&nbsp;|&#160;)+/g, ' ')      // Remove non-breaking spaces
      .replace(/&(?![a-zA-Z0-9#]+;)/g, '&amp;')
      .replace(/<br\s*>/gi, '<br />')         // Normalize <br> to self-closing <br />
      .replace(/<img([^>]*)(?<!\/)>/gi, '<img$1 />'); // Self-close <img>

    // ✅ Sanitize MS Word tags
    decoded = this.sanitizeWordHtml(decoded);

    // ✅ DO NOT split or wrap in <p>, just keep <br /> for spacing
    // This preserves exact spacing for letters

    // ✅ Convert bullet symbols to proper list
    decoded = decoded.replace(/(•|▪|‣|\u2022)\s*(.*?)(?=<br|$)/gi, '<ul><li>$2</li></ul>');

    // ✅ Auto-close unclosed tags
    const tagsToClose = ['div', 'ul', 'ol', 'li', 'table', 'tr', 'td', 'thead', 'tfoot', 'tbody', 'span', 'b', 'i', 'u', 'strong', 'em'];
    tagsToClose.forEach(tag => {
      const openCount = (decoded.match(new RegExp(`<${tag}(\\s[^>]*)?>`, 'gi')) || []).length;
      const closeCount = (decoded.match(new RegExp(`</${tag}>`, 'gi')) || []).length;
      if (openCount > closeCount) {
        decoded += `</${tag}>`.repeat(openCount - closeCount);
      }
    });

    // ✅ Wrap content in XHTML structure
    const wrapper = document.createElement('div');
    wrapper.innerHTML = decoded;

    const doc = document.implementation.createDocument('', '', null);
    const htmlEl = doc.createElement('html');
    htmlEl.setAttribute('xmlns', 'http://www.w3.org/1999/xhtml');

    const headEl = doc.createElement('head');
    const styleEl = doc.createElement('style');
    styleEl.textContent = `
    @page {
      size: A4;
      margin-top: 120px;
      margin-bottom: 130px;
      margin-left: 50px;
      margin-right: 40px;
    }
    body {
      margin: 0;n
      padding: 0;
      font-family: Arial, sans-serif;
      font-size: 12pt;
      line-height: 1.4;
    }
    br {
      line-height: 1.4;
    }
    ul, ol {
      margin-left: 20px;
      padding-left: 20px;
    }
    li {
      margin-bottom: 4px;
    }
  `;
    headEl.appendChild(styleEl);

    const bodyEl = doc.createElement('body');
    Array.from(wrapper.childNodes).forEach(node => {
      bodyEl.appendChild(doc.importNode(node, true));
    });

    htmlEl.appendChild(headEl);
    htmlEl.appendChild(bodyEl);
    doc.appendChild(htmlEl);

    const finalXhtml = new XMLSerializer().serializeToString(doc);
    return `<!DOCTYPE html>\n${finalXhtml}`;
  }










  sanitizeWordHtml(html: string): string {
    // Step 1: Initial cleanup using regex
    const cleaned = html
      .replace(/<\?xml[^>]*\?>/gi, '')
      .replace(/xmlns(:\w+)?="[^"]*"/gi, '')
      .replace(/<(\/?)(o|w|v|m|st1):[^>]*>/gi, '')
      .replace(/<!--\[if [\s\S]*?<!\[endif\]-->/gi, '')
      .replace(/<!--[\s\S]*?-->/g, '')
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<meta[^>]*>/gi, '')
      .replace(/\s+[a-z]+:[a-z\-]+="[^"]*"/gi, '')

      // Self-closing void elements (to be XHTML-compliant)
      .replace(/<br([^>]*)>/gi, '<br$1 />')
      .replace(/<hr([^>]*)>/gi, '<hr$1 />')
      .replace(/<img([^>]*?)(?<!\/)>/gi, '<img$1 />')
      .replace(/<input([^>]*)>(?!<\/input>)/gi, '<input$1 />')

      // Strip invalid attributes (namespaced)
      .replace(/<([a-z1-6]+)([^>]*)>/gi, (match, tag, attrs) => {
        const cleanedAttrs: string[] = [];
        const attrRegex = /([a-zA-Z0-9\-:_]+)\s*=\s*(['"])(.*?)\2/g;
        let m;
        while ((m = attrRegex.exec(attrs)) !== null) {
          if (!m[1].includes(':')) {
            cleanedAttrs.push(`${m[1]}="${m[3]}"`);
          }
        }
        return `<${tag}${cleanedAttrs.length ? ' ' + cleanedAttrs.join(' ') : ''}>`;
      });

    // Step 2: Create a DOM wrapper and let browser auto-fix structure
    const wrapper = document.createElement('div');
    wrapper.innerHTML = cleaned;

    // Step 3: Manually walk DOM and ensure strict XHTML-compliant closing
    const forceTagClosing = (node: Node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node as HTMLElement;
        const tagName = el.tagName.toLowerCase();

        // For tags that must have a closing tag even if empty (e.g. <a></a>)
        const forceClosingTags = ['a', 'b', 'i', 'u', 'span', 'strong', 'em', 'p', 'div', 'td', 'th', 'tr', 'thead', 'tbody', 'tfoot'];

        if (forceClosingTags.includes(tagName) && el.innerHTML.trim() === '') {
          el.innerHTML = '&#8203;'; // zero-width space to enforce closing tag
        }
      }

      for (let i = 0; i < node.childNodes.length; i++) {
        forceTagClosing(node.childNodes[i]);
      }
    };

    forceTagClosing(wrapper);

    // Step 4: Serialize DOM back to XHTML
    let xhtml = new XMLSerializer().serializeToString(wrapper);

    // Step 5: Remove outer <div> wrapper added for parsing
    xhtml = xhtml.replace(/^<div[^>]*>/i, '').replace(/<\/div>$/i, '');

    return xhtml;
  }

}
